
export default {
  name: 'AccordionSelectMenu',
  props: {
    // [{ text: 'POPULARITY', value: '인기순',}]
    menuOptions: { type: Array, required: true },
    selectedOption: { type: String, default: '' },
    placeHolder: { type: String, required: false, default: '' },
    optionHeight: { type: Number, required: false, default: 32 },
    fontStyle: { type: String, required: false, default: 'h-r-sm' },
  },
  data() {
    return {
      isAccordionOpen: false,
    };
  },
  computed: {
    selectedItem() {
      return this.menuOptions.find(o => o.value === this.selectedOption);
    },
  },
  methods: {
    onClickOption(v) {
      this.isAccordionOpen = false;
      this.$emit('select-option', v);
    },
  },
};
